function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import Environment from '@polleverywhere/core/lib/models/environment';
import URI from 'urijs';
var env = new Environment();

function hostFromUrl(url) {
  var _window, _window$location;

  return URI(url).absoluteTo(((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href) || '/').host();
}

var TokenStore = /*#__PURE__*/function () {
  function TokenStore() {
    _defineProperty(this, "cache", {});
  }

  var _proto = TokenStore.prototype;

  _proto.has = function has(url) {
    return !!this.cache[hostFromUrl(url)];
  };

  _proto.get = function get(url) {
    return this.cache[hostFromUrl(url)];
  };

  _proto.set = function set(url, token) {
    this.cache[hostFromUrl(url)] = token;
    return token;
  };

  _proto.reset = function reset() {
    this.cache = {};
  }
  /*
  * True if the given URL should have the X-CSRF-Token header set
  */
  ;

  _proto.expectedFor = function expectedFor(url) {
    var _window2, _window2$location; // Assume we expect a token if we have already received on for this host


    if (this.has(url)) {
      return true;
    }

    var host = hostFromUrl(url);
    var whitelist = [env.get('api_url'), env.get('root_url'), URI((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href)];
    return whitelist.find(function (uri) {
      return uri.host() === host;
    });
  };

  return TokenStore;
}();

var tokenStore = new TokenStore();
export default tokenStore;